import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["value", "label"];
import React from 'react';
import { SearchItem } from '@ellucian/react-design-system/core/Search';
import PropTypes from 'prop-types';
var DropdownTypeaheadItem = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var value = props.value,
    label = props.label,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/React.createElement(SearchItem, _extends({
    ref: ref,
    "data-value": value,
    divider: true
  }, rest), label);
});
DropdownTypeaheadItem.muiName = 'DropdownTypeaheadItem';
DropdownTypeaheadItem.displayName = 'DropdownTypeaheadItem';
DropdownTypeaheadItem.propTypes = {
  /**
   * Text of the dropdown item
   */
  label: PropTypes.string.isRequired,
  /**
   * The value.
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired,
  /**
   * If `true`, the dropdown item will be disabled, and unselectable.
   */
  disabled: PropTypes.bool,
  /**
   * Icon to be displayed to the the left of the text
   */
  LeftIconComponent: PropTypes.node,
  /**
   * Icon to be displayed to the the right of the text
   */
  RightIconComponent: PropTypes.node
};
DropdownTypeaheadItem.defaultProps = {
  disabled: false,
  LeftIconComponent: null,
  RightIconComponent: null
};
export default DropdownTypeaheadItem;